import GraphicProperties from '../3D/graphic-properties/graphic-properties.model';
import { MatFlexLineUtilizationFactor } from './mat-flex-line-utlization-factor.model';
import { Material } from './material.model';

export class MatFlexLine implements Material {
  id: number;
  title: string;
  structure: string;
  structureId: number;
  lineSectionTag: string;
  internalId: number;
  finiteElement: string;
  formulation: string;
  dampingMass: boolean;
  dampingStiffness: boolean;
  detailedFloater: boolean;
  hydrodynamicModel: number;
  numCrosSection: number;
  velTolVortex: number;
  disParamVortex: number;
  flowVelCutOff: number;
  checkFlowRegime: boolean;
  dvmAutomaticStep: number;
  dvmOutput: number;
  hydrodynamicStrakeModel: string;
  internalSnCurveId: number;
  externalSnCurveId: number;
  postScf: number;
  shear7SnCurveId: number;
  shear7StressFactor: number;
  shear7Bandwidth: number;
  shear7Strouhal: number;
  shear7ReductionFactor: number;
  shear7ZoneType: number;
  shear7HydroDampingCoeff1: number;
  shear7HydroDampingCoeff2: number;
  shear7HydroDampingCoeff3: number;
  databaseName: string;
  cofData: string;
  cofFileName: string;
  internalDiameter: number;
  externalDiameter: number;
  hidrodynamicDiameter: number;
  weightDry: number;
  weightWet: number;
  morisonInertia: number;
  morisonDrag: number;
  morisonDragLongi: number;
  stiffAxial: number;
  stiffAxialDynamic: number;
  stiffBending: number;
  stiffTorsional: number;
  floaterWeight: number;
  floaterBuoyancy: number;
  floaterDiameter: number;
  floaterWidth: number;
  floaterSpecificWeight: number;
  floaterSpacing: number;
  rayleighPeriodFirst: number;
  rayleighPeriodSecond: number;
  rayleighDampingFirst: number;
  rayleighDampingSecond: number;
  floaterEfficiencyFactor: number;
  thermalCoefficient: number;
  preSlipBendingStiffness: number;
  limitBendingMoment: number;
  capacityCurve: number;
  hydrostaticEffect: string;
  initialTension: number;
  flexibleUfMethod: number;
  flexUfDpull: number;
  flexUfOdPs: number;
  flexUfOdEs: number;
  flexUfSdp: number;
  flexUfDp: number;
  flexUfMys: number;

  hysteresis: boolean;
  staticTimeFunctionId: number;
  dynamicTimeFunctionId: number;

  utilizationFactor: MatFlexLineUtilizationFactor;

  needsUpdate?: boolean;
  graphicProperties?: GraphicProperties;

  constructor() {}
}
